<ng-container *ngIf="stepInput.isBulkEdit">
  <div style="width: 95%">
    <app-items-for-bulk-edit
      [selectedItems]="stepInput.selectedLineItem"
      entityType="line_item"
      step="geo"
      [isBulkEdit]="true"
      dspType="bdsp"
    >
    </app-items-for-bulk-edit>
  </div>
</ng-container>

<div [ngClass]="{ 'mt-3': stepInput.isBulkEdit }">
  <div>
    <div class="flex_row mb-3">
      <mat-chip-listbox>
        <mat-chip-option
          (click)="getGeoChip('geo')"
          [selected]="selectedGeoChip == 'geo'"
        >
          {{ !stepInput.isBulkEdit ? "Country/Region/Cities" : "Country" }}
        </mat-chip-option>
        <mat-chip-option
          *ngIf="showMetroCode && !stepInput.isBulkEdit && !stepInput.isDlvMod"
          (click)="getGeoChip('dma')"
          [selected]="selectedGeoChip == 'dma'"
        >
          DMA Codes
        </mat-chip-option>
        <mat-chip-option
          *ngIf="!stepInput.isDlvMod"
          (click)="getGeoChip('postal_codes')"
          [selected]="selectedGeoChip == 'postal_codes'"
        >
          Postal Codes
        </mat-chip-option>
        <mat-chip-option
          *ngIf="
            !stepInput.isDlvMod ||
            !this.stepInput.isBulkEdit ||
            stepInput.selectedFields.includes('lat_long_list')
          "
          (click)="selectedGeoChip = 'custom_location'"
          [selected]="selectedGeoChip == 'custom_location'"
        >
          Custom Location
        </mat-chip-option>
      </mat-chip-listbox>
    </div>
  </div>
</div>

<div class="list_container me-2" *ngIf="selectedGeoChip == 'geo'">
  <div class="mt-4 ms-3 me-3 mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <mat-form-field class="no-padding list-search" appearance="outline">
        <input
          matInput
          class="placeholders search-input-shadow"
          (keyup)="searchGeoData($event)"
          [(ngModel)]="geoSearchTerm"
          placeholder="Search {{ geoPrurals[selectedGeoTab] }}"
          #input
        />
        <mat-icon matSuffix class="material-icons search_icon">
          search
        </mat-icon>
      </mat-form-field>
    <div class="warning_message">
      At least one geo-targeting option (Country, City, or Region) must be selected.
    </div>
    </div>
    <div class="mt-2">
      <div class="tab-content">
        <div
          *ngIf="!stepInput.isDlvMod || selectedTrgts.includes('country')"
          (click)="getGeoTab('country')"
          [ngClass]="{
            nav_tab: true,
            active: this.selectedGeoTab === 'country'
          }"
        >
          Countries
        </div>
        <div
          *ngIf="!stepInput.isDlvMod || selectedTrgts.includes('country')"
          (click)="getGeoTab('region')"
          [ngClass]="{
            nav_tab: true,
            active: this.selectedGeoTab === 'region'
          }"
        >
          Region
        </div>
        <div
          *ngIf="!stepInput.isDlvMod || selectedTrgts.includes('city')"
          (click)="getGeoTab('city')"
          [ngClass]="{ nav_tab: true, active: this.selectedGeoTab === 'city' }"
        >
          Cities
        </div>
      </div>
      <div class="filter-chip-geo" *ngIf="geoFilter">
        <mat-chip-option [removable]="true">
          <div class="table_value_name mt-2">
            <label> {{ geoFilter.name }}</label>
          </div>

          <mat-icon matChipRemove (click)="removeGeoFilter()">cancel</mat-icon>
        </mat-chip-option>
      </div>
    </div>

    <div class="deals_container mt-3">
      <div class="deals_sub_container">
        <div>
          <table
            mat-table
            #geoSort="matSort"
            [dataSource]="dataSourceGeo"
            matSort
          >
            <ng-container matColumnDef="checkbox">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let row">
                <ng-container *ngIf="stepInput.isDlvMod; else trgtAction">
                  <label class="checkbox-container">
                    <input
                      type="checkbox"
                      (click)="addGeo(row, 'include', $event)"
                    />
                    <span class="checkboxmark"></span>
                  </label>
                </ng-container>

                <ng-template #trgtAction>
                  <ng-container
                    *ngIf="
                      !stepInput.isBulkEdit ||
                      bulkEditTrgtAct.country != 'remove_all'
                    "
                  >
                    <span
                      matTooltip="Select to INCLUDE in targeting"
                      [ngClass]="{
                        'material-icons me-2': true,
                        'include-icon-selected': isIncludeGeo(),
                        'include-icon': !isIncludeGeo()
                      }"
                      (click)="
                        isIncludeGeo() ? addGeo(row, 'include', $event) : ''
                      "
                    >
                      check
                    </span>

                    <span
                      matTooltip="Select to EXCLUDE in targeting"
                      [ngClass]="{
                        'material-icons': true,
                        'exclude-icon-selected': isExcludeGeo(),
                        'exclude-icon': !isExcludeGeo()
                      }"
                      (click)="
                        isExcludeGeo() ? addGeo(row, 'exclude', $event) : ''
                      "
                    >
                      block
                    </span>
                  </ng-container>
                </ng-template>
              </td>
            </ng-container>
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"> ID </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name">{{ row.id }}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"> Name </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <a
                  class="table_value_name pointer"
                  style="color: black"
                  (click)="!stepInput.isBulkEdit ? getFilteredGeo(row) : ''"
                >
                  {{ row.name }}</a
                >
              </td>
            </ng-container>
            <ng-container matColumnDef="region_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"> Region Name </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name" style="color: black">
                  {{ row.region_name }}</span
                >
              </td>
            </ng-container>
            <ng-container matColumnDef="country_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"> Country Name </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name" style="color: black">
                  {{ row.country_name }}</span
                >
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColumnGeo"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumnGeo"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">No data matching the filter</td>
            </tr>
          </table>
          <mat-paginator
            #geoPaginator
            [pageSizeOptions]="[10, 25, 100]"
            (page)="handlePageEvent($event)"
            [length]="pageLength"
          >
          </mat-paginator>
        </div>
      </div>
      <mat-divider [vertical]="true"></mat-divider>
      <div class="deals_sub_container">
        <div class="mb-2" *ngIf="stepInput.isBulkEdit">
          <div class="field-name">Operation:</div>
          <mat-radio-group [(ngModel)]="bulkEditTrgtAct.country">
            <mat-radio-button
              class="ms-2"
              *ngFor="let item of trgtOperations"
              [value]="item.value"
              [matTooltip]="item.toolTip"
              (change)="checkOperation('country', item.value)"
            >
              {{ item.label }}
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="flex_column fix-height">
          <mat-list>
            <mat-list-item>
              <div class="flex_row_space_between">
                <div class="flex_row">
                  <span class="field-name mt-1">Name</span>
                </div>
                <div class="flex_row">
                  <span class="field-name mt-1 me-2"></span>
                  <span
                    class="material-icons mt-1 me-2"
                    style="cursor: pointer; color: gray"
                    (click)="removeAllGeo()"
                  >
                    cancel
                  </span>
                </div>
              </div>
            </mat-list-item>
          </mat-list>

          <div class="selected-list-content">
            <div *ngIf="geoObject.length > 0" class="list_container_content">
              <div class="country-group">
                <div
                  *ngFor="let geo of geoObject; let l = last; let i = index"
                  class="item-group"
                >
                  <div class="country-group-item">
                    <span class="flex_row">
                      <div *ngIf="geo.country_included">
                        <span
                          *ngIf="country_action == 'include'"
                          class="material-icons include-icon-selected me-2"
                        >
                          check
                        </span>
                        <span
                          *ngIf="country_action == 'exclude'"
                          class="material-icons exclude-icon-selected me-2"
                        >
                          block
                        </span>
                      </div>
                      <span> {{ geo.country.name }} </span>
                    </span>
                    <span
                      *ngIf="geo.country_included"
                      class="material-icons"
                      style="cursor: pointer; color: gray"
                      (click)="removeCountry(i)"
                      >cancel</span
                    >
                  </div>
                  <mat-divider *ngIf="!l"></mat-divider>
                  <div *ngFor="let rgn of geo.regions; let j = index">
                    <div class="region-group-item">
                      <span class="flex_row">
                        <div *ngIf="rgn.region_included">
                          <span
                            *ngIf="region_action == 'include'"
                            class="material-icons include-icon-selected me-2"
                          >
                            check
                          </span>
                          <span
                            *ngIf="region_action == 'exclude'"
                            class="material-icons exclude-icon-selected me-2"
                          >
                            block
                          </span>
                        </div>
                        <span> {{ rgn.region.name }} </span>
                      </span>
                      <span
                        *ngIf="rgn.region_included"
                        class="material-icons"
                        style="cursor: pointer; color: gray"
                        (click)="removeRegion(i, j)"
                        >cancel</span
                      >
                    </div>
                    <mat-divider></mat-divider>
                    <div *ngFor="let city of rgn.cities; let k = index">
                      <div class="city-group-item">
                        <span class="flex_row">
                          <div>
                            <span
                              *ngIf="city_action == 'include'"
                              class="material-icons include-icon-selected me-2"
                            >
                              check
                            </span>
                            <span
                              *ngIf="city_action == 'exclude'"
                              class="material-icons exclude-icon-selected me-2"
                            >
                              block
                            </span>
                          </div>
                          <span> {{ city.name }} </span>
                        </span>
                        <span
                          class="material-icons"
                          style="cursor: pointer; color: gray"
                          (click)="removeCity(i, j, k)"
                          >cancel</span
                        >
                      </div>
                      <mat-divider></mat-divider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="list_container me-2" *ngIf="selectedGeoChip == 'dma'">
  <div class="mt-4 ms-3 me-3 mb-4">
    <div>
      <label class="field-name"> US DMA Codes </label>
    </div>
    <div>
      <mat-form-field
        class="no-padding search-input-shadow list-search"
        appearance="outline"
      >
        <input
          matInput
          class="placeholders"
          (keyup)="searchDma($event)"
          placeholder="Search DMA"
          #input
        />
        <mat-icon matSuffix class="material-icons search_icon">
          search
        </mat-icon>
      </mat-form-field>
    </div>

    <div class="deals_container mt-3">
      <div class="deals_sub_container">
        <div>
          <table
            mat-table
            #metroSort="matSort"
            [dataSource]="dataSourceMetro"
            matSort
          >
            <ng-container matColumnDef="checkbox">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let row">
                <span
                  matTooltip="Select to INCLUDE in targeting"
                  [ngClass]="{
                    'material-icons me-2': true,
                    'include-icon-selected': isIncluded(metro_action),
                    'include-icon': !isIncluded(metro_action)
                  }"
                  (click)="addDma(row, 'include')"
                >
                  check
                </span>

                <span
                  matTooltip="Select to EXCLUDE in targeting"
                  [ngClass]="{
                    'material-icons': true,
                    'exclude-icon-selected': isExcluded(metro_action),
                    'exclude-icon': !isExcluded(metro_action)
                  }"
                  (click)="addDma(row, 'exclude')"
                >
                  block
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"> ID </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name">{{ row.id }}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"> Name </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name" style="color: black">
                  {{ row.name }}</span
                >
              </td>
              checkblock
            </ng-container>
            <ng-container matColumnDef="key">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"> Code </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name" style="color: black">
                  {{ row.key }}</span
                >
              </td>
              checkblock
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColumnMetro"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumnMetro"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">No data matching the filter</td>
            </tr>
          </table>
          <mat-paginator
            #metroPaginator
            [pageSizeOptions]="[10, 25, 100]"
            (page)="handlePageEvent($event)"
            [length]="dmaPageLength"
          >
          </mat-paginator>
        </div>
      </div>
      <mat-divider [vertical]="true"></mat-divider>
      <!-- selectedDma -->
      <div class="deals_sub_container">
        <div>
          <label class="field-name"> Selected DMA Codes </label>
        </div>

        <div class="flex_column fix-height">
          <mat-list>
            <mat-list-item>
              <div class="flex_row_space_between">
                <div class="flex_row alignDMAName">
                  <span class="field-name mt-1 ms-5">Name</span>
                </div>
                <div class="flex_row">
                  <span class="field-name mt-1 ms-2">Code</span>
                </div>
                <div class="flex_row">
                  <span class="field-name mt-1 me-2"></span>
                  <span
                    class="material-icons mt-1 me-2"
                    style="cursor: pointer; color: gray"
                    (click)="removeAllDma()"
                  >
                    cancel
                  </span>
                </div>
              </div>
            </mat-list-item>
          </mat-list>
          <!-- selectedDma -->
          <div class="selected-list-content">
            <div
              *ngIf="selectedMetro.length > 0"
              class="list_container_content"
            >
              <div class="country-group">
                <div
                  *ngFor="let item of selectedMetro; let l = last"
                  class="item-group"
                >
                  <div>
                    <div class="country-group-item">
                      <div class="flex_row alignDMAName">
                        <div class="mt-1 me-2">
                          <span
                            matTooltip="Select to INCLUDE in targeting"
                            class="material-icons include-icon-selected"
                            *ngIf="metro_action == 'include'"
                          >
                            check
                          </span>
                          <span
                            matTooltip="Select to EXCLUDE in targeting"
                            class="material-icons ms-2 exclude-icon-selected"
                            *ngIf="metro_action == 'exclude'"
                          >
                            block
                          </span>
                        </div>
                        <span
                          [ngClass]="{
                            'mt-1': true,
                            'ms-3': metro_action == 'include',
                            'ms-1': metro_action == 'exclude'
                          }"
                        >
                          {{ item.name }}
                        </span>
                      </div>
                      <div class="flex_row">
                        <span class="mt-1">
                          {{ item.key }}
                        </span>
                      </div>
                      <div class="flex_row">
                        <span
                          class="material-icons"
                          style="cursor: pointer; color: gray"
                          (click)="removeDma(item)"
                        >
                          cancel
                        </span>
                      </div>
                    </div>
                    <mat-divider *ngIf="!l"></mat-divider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="me-2" *ngIf="selectedGeoChip == 'postal_codes'">
  <div class="list_container">
    <div class="postal-codes-container">
      <div class="deals_container">
        <div class="deals_sub_container">
          <div class="text-input-inventory">
            <textarea
              [(ngModel)]="inputZipCodes"
              rows="10"
              placeholder="Enter postal codes separated by commas or newlines."
              style="width: 100%"
            >
            </textarea>
          </div>

          <ng-container
            *ngIf="!stepInput.isBulkEdit || bulkEditTrgtAct.zip != 'remove_all'"
          >
            <div class="text-input-action">
              <button
                mat-button
                class="action_btn_no-border me-2"
                (click)="clearAllTextFromPostalTextArea()"
              >
                Clear
              </button>
              <button
                [disabled]="!inputZipCodes"
                mat-button
                class="create-btn me-2 mb-2"
                (click)="addPostalCodes()"
              >
                Add
              </button>
            </div>
          </ng-container>
        </div>
        <mat-divider [vertical]="true"></mat-divider>
        <div class="deals_sub_container">
          <div class="mb-2" *ngIf="stepInput.isBulkEdit">
            <div class="field-name">Operation:</div>
            <mat-radio-group [(ngModel)]="bulkEditTrgtAct.zip">
              <mat-radio-button
                class="ms-2"
                *ngFor="let item of trgtOperations"
                [value]="item.value"
                [matTooltip]="item.toolTip"
                (change)="checkOperation('zip')"
              >
                {{ item.label }}
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <div class="flex_column fix-height">
            <div>
              <div class="warning_message mb-2" *ngIf="stepInput.isGambling">
                Postal Code targeting is available only for selected countries.
                Please click this link
                <a class="active pointer-cursor ms-1" (click)="avlCtryForTar()"
                  >to view the list.</a
                >
              </div>
              <div class="flex_column">
                <div class="list_container">
                  <div class="flex_row_space_between mt-2 mb-2 ms-2 me-2">
                    <span class="mt-1 table_header_name"> Postal Codes </span>
                    <div class="list-item-action align-right">
                      <span
                        matTooltip="Select to INCLUDE in targeting"
                        (click)="
                          !stepInput.isBulkEdit ||
                          (this.stepInput.isBulkEdit &&
                            this.stepInput.areZipTargetsEmpty)
                            ? updatePostalCodeAction('include')
                            : ''
                        "
                        [ngClass]="{
                          'material-icons': true,
                          'include-icon-selected': zip_action == 'include',
                          'include-icon': zip_action == 'exclude'
                        }"
                      >
                        check
                      </span>
                      <span
                        matTooltip="Select to EXCLUDE in targeting"
                        (click)="
                          !stepInput.isBulkEdit ||
                          (this.stepInput.isBulkEdit &&
                            this.stepInput.areZipTargetsEmpty)
                            ? updatePostalCodeAction('exclude')
                            : ''
                        "
                        [ngClass]="{
                          'material-icons': true,
                          'exclude-icon-selected': zip_action == 'exclude',
                          'ms-2': true,
                          'exclude-icon': zip_action == 'include'
                        }"
                      >
                        block
                      </span>
                    </div>

                    <span
                      (click)="removeAllPostalCodes()"
                      class="material-icons me-3"
                      style="cursor: pointer; color: gray"
                    >
                      cancel
                    </span>
                  </div>
                  <div>
                    <mat-divider [vertical]="false"></mat-divider>
                  </div>
                  <div class="selected-postal-codes">
                    <mat-chip-listbox style="width: 100%">
                      <mat-chip-option
                        *ngFor="let code of selectedZip; let i = index"
                        [removable]="true"
                        (removed)="removeSelectedPostalCodes(i)"
                      >
                        {{ code }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                      </mat-chip-option>
                    </mat-chip-listbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="selectedGeoChip == 'custom_location'">
  <app-bdsp-inventory-listing
    [stepInput]="{
      globalParams: stepInput.globalParams,
      selectedLists: stepInput.customLocs,
      name: 'Custom Location List',
      type: 'lat_long_list',
      bulkEditAction: stepInput.isBulkEdit
        ? bulkEditTrgtAct.lat_long_list
        : false,
      key: 'geo',
      isBulkEdit: stepInput.isBulkEdit,
      isMulAction: true,
      ctryToTarget: ctryToTarget,
      isGambling: stepInput.isGambling
    }"
  >
  </app-bdsp-inventory-listing>
</ng-container>
